import memoryStore from './memoryStore';
export default globalThis.sessionStorage || memoryStore;